import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { requireSettingsSection } from '../../lib/router/route-guards';

const AttributesSelectorPage = lazy(() =>
  import('../../pages/settings/attributes/AttributesSelectorPage').then((m) => ({ default: m.AttributesSelectorPage })),
);

export const Route = createFileRoute('/settings/attributes/$categoryId')({
  beforeLoad: ({ context }) => requireSettingsSection(context.queryClient, 'attributes'),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <AttributesSelectorPage />
    </Suspense>
  ),
});
